import { createContext, useContext } from "react";

export const SessaoContext = createContext(null);

export const useSessao = () => {
  const context = useContext(SessaoContext);
  if (!context) {
    throw new Error("useSessao deve ser usado dentro de SessaoContext.Provider");
  }
  return context;
};
